import Const from "./const";

function Util() {
    return {
        parseDate: parseDate,
        clearData: clearData,
        timeFormat: timeFormat,
        is: is,
        clone: clone,
        time: time,
        convertMoney: convertMoney,
        get: get,
        sortType: sortType,
        getUserAvatarUrl: getUserAvatarUrl,
        getUploadImgUrl: getUploadImgUrl,
        displayUserName: displayUserName,
        isHttpNotWX: isHttpNotWX,
        getImgUrl: getImgUrl,
        getImgUrlList: getImgUrlList,
        isHttp: isHttp,
        stringTruncate: stringTruncate,
        getFilenameExt:getFilenameExt,
        dateFormat: dateFormat,
        isImage:isImage,
        eigthNumberForPosition: eigthNumberForPosition,
        compareVersion: compareVersion,
    };
    function eigthNumberForPosition (num) {
        let str = num.toString();
        let newStr = str.substring(0,9);
        return Number(newStr);
    }
    
    function dateFormat(second_time) {
        let second = parseInt(second_time);
        if (parseInt(second_time) > 60) {
            let second = parseInt(second_time) % 60;
            let min = parseInt(second_time / 60);
            if (min > 60) {
                min = parseInt(second_time / 60) % 60;
                let hour = parseInt(parseInt(second_time / 60) / 60);
                if (hour > 24) {
                    hour = parseInt(parseInt(second_time / 60) / 60) % 24;
                    let day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
                    time = [day, hour, fill_zero_prefix(min), fill_zero_prefix(second)];
                } else {
                    time = [0, hour, fill_zero_prefix(min), fill_zero_prefix(second)];
                }
            } else {
                time = [0, 0, fill_zero_prefix(min), fill_zero_prefix(second)];
            }
        } else {
            time = [0, 0, 0, fill_zero_prefix(second)];
        }
    
        return time;
    }
    function fill_zero_prefix(num) {
        return num < 10 ? "0" + num : num
    }
    function getFilenameExt(file) {
        if (file.type) {
            let type = file.type
            return type.substring(type.lastIndexOf('/') + 1)
        }else if (file.raw && file.raw.type) {
            let type = file.raw.type
            return type.substring(type.lastIndexOf('/') + 1)
        } else {
            return 'doc'
        }
    }
    function isImage(name) {
        let imgList = Const.IMAGE_TYPE;
        let flag = false;
        imgList.forEach(item => {
            if(new RegExp(`${item}$`).test(name)) {
                flag = true
            }
        });
        return flag
    }
    function parseDate(date) {
        return parseInt(new Date(date).getTime() / 1000);
    }

    function clearData(data) {
        Object.keys(data).forEach(function (key) {
            if (is('object', data[key])) {
                data[key] = {};
            }
            if (is('array', data[key])) {
                data[key] = [];
            }
            if (is('number', data[key])) {
                data[key] = "";
            }
            if (is('string', data[key])) {
                data[key] = "";
            }
        })
    }

    function isHttp(content) {
        if(/https:\/\/mp.weixin.qq.com\/s\/([0-9a-zA-Z-_]+)/.test(content)) {
            return true
        } else {
            return false
        }
    }

    function isHttpNotWX(content) {
        if(/(http|https):\/(\/[0-9a-zA-Z-_]+)+/.test(content)) {
            return true
        } else {
            return false
        }
    }

    function numberFormat(n) {
        n = n.toString();
        return n[1] ? n : '0' + n;
    }

    function timeFormat(timeStamp, detail) {
        if (timeStamp <= 0) {
            return '--';
        }
        let date = new Date(timeStamp * 1000);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();

        // xxxx/xx/xx xx:xx:xx
        if (detail === 1) {
            return [year, month, day].map(numberFormat).join('/') + ' ' + [hour, minute, second].map(numberFormat).join(':');
        }
        // xxxx-xx-xx xx:xx
        if (detail === 2) {
            return [year, month, day].map(numberFormat).join('-') + ' ' + [hour, minute].map(numberFormat).join(':');
        }
        if (detail === 3) {
            return [year, month, day].map(numberFormat).join('/') + ' ' + [hour, minute].map(numberFormat).join(':');
        }

        if (detail === 'y-m-d h:m') {
            return [year, month, day].map(numberFormat).join('-') + ' ' + [hour, minute].map(numberFormat).join(':');
        }

        // xxxx-xx-xx
        if (detail === 3) {
            return [year, month, day].map(numberFormat).join('-');
        }

        // xx/xx xx:xx
        if (detail === 4) {
            return [month, day].map(numberFormat).join('/') + " " + [hour, minute].map(numberFormat).join(':');
        }

        // 当天返回 xx : xx , 其他返回 xxxx/xx/xx
        if (detail === 5) {
            let todayBegin = getTodayBegin();
            let todayEnd = getTodayEnd();
            if (timeStamp > todayBegin && timeStamp < todayEnd) {
                return [hour, minute].map(numberFormat).join(':');
            }
            return [year, month, day].map(numberFormat).join('/');
        }

        // 当天返回 xx小时之前，其他返回几天前
        if (detail === 6) {
            let nowTime = new Date().getTime()
            let timeDelta = nowTime / 1000 - timeStamp
            if(timeDelta / 86400 <= 1) {
                let hours = parseInt(timeDelta / 3600)
                if(hours === 0) {
                    let minutes = parseInt(timeDelta / 60)
                    if(minutes === 0) {
                        return '刚刚'
                    } else {
                        return `${minutes}分钟前`
                    }
                } else {
                    return `${hours}小时前`
                }
            } else {
                let days = parseInt(timeDelta / 86400)
                if(days > 30) {
                    return '很久以前'
                } else {
                    return `${days}天前`
                }
            }
        }

        // x月x日 xx:xx
        return [month, day].map(numberFormat).join('月') + '日 ' + [hour, minute].map(numberFormat).join(':');
    }

    function is(type, obj) {
        let item;
        item = Object.prototype.toString.call(obj).slice(8, -1);
        return obj !== undefined && obj !== null && item.toLowerCase() === type.toLowerCase()
    }

    function clone(obj) {
        let o;
        if (typeof obj === "object") {
            if (obj === null) {
                o = null;
            } else {
                if (obj instanceof Array) {
                    o = [];
                    for (let i = 0, len = obj.length; i < len; i++) {
                        o.push(clone(obj[i]));
                    }
                } else {
                    o = {};
                    for (let j in obj) {
                        o[j] = clone(obj[j]);
                    }
                }
            }
        } else {
            o = obj;
        }
        return o;
    }

    function getImgUrl(img) {
        if (img && img.indexOf('http') >= 0) {
            return img
        }
        if (!img) {
            return '/static/assets/icon/icon-avatar@2x.png'
        }
        return Const.NET.IMG_URL_PREFIX + img;
    }

    function getImgUrlList(imgList) {
        if (!imgList.length) {
            return []
        }

        let resultList = [];

        imgList.forEach(lt => {
            resultList.push(Const.NET.IMG_URL_PREFIX + lt)
        });
        return resultList
    }

    function time() {
        return parseInt(new Date().getTime() / 1000, 10);
    }

    function convertMoney(money) {
        if (!money) {
            return 0;
        }
        return parseInt(money) * 100;
    }

    function get(obj, key) {
        return key.split(".").reduce(function (o, x) {
            return (typeof o === "undefined" || o === null) ? o : o[x];
        }, obj);
    }

    function sortType(prop, order) {
        let sortList = Const.DEVICE_SORT_PROP_LIST;
        let index = sortList.findIndex(item => item === prop);
        // 'ascending'  'descending'
        let temp = 0;
        if(order === 'descending') {
            temp = -1;
        }
        return index > -1 ?  2 * (index + 1) + temp : 1;
    }

    function getUserAvatarUrl(user, anonymous) {
        if (anonymous) {
            return '/static/assets/icon/default-avatar.jpg'
        }
        if (!user) {
            return '/static/assets/icon/default-avatar.jpg'
        }

        if (!user.avatar) {
            return '/static/assets/icon/default-avatar.jpg'
        }

        if (user.avatar.indexOf('http') >= 0) {
            return user.avatar;
        }

        return Const.NET.IMG_URL_PREFIX + user.avatar;
    }

    function getUploadImgUrl(data) {
        if(!data) {
            return '/static/assets/icon/icon-avatar@2x.png'
        }
        if(data.code) {
            return '/static/assets/icon/icon-avatar@2x.png'
        }
        if(data.cover) {
            return Const.NET.IMG_URL_PREFIX + data.cover
        }
        if(data.name) {
            return Const.NET.IMG_URL_PREFIX + data.name
        }
        if(data.data) {
            return Const.NET.IMG_URL_PREFIX + data.data.name
        }
    }

    function displayUserName(user, anonymous) {
        if (anonymous) {
            return "匿名"
        }

        if (!user) {
            return "匿名"
        }

        if (user.name) {
            return user.name
        }

        if (user.nickname) {
            return user.nickname
        }

        return "匿名"
    }

    function stringTruncate(str, len) {
        var temp;
        var icount = 0;
        var patrn = /[^\x00-\xff]/;
        var strre = "";
        var leng = str.length;
        for (var i = 0; i < leng; i++) {
            if (icount < len - 1) {
                temp = str.substr(i, 1);
                if (patrn.exec(temp) == null) {
                    icount = icount + 1
                } else {
                    icount = icount + 2
                }
                strre += temp
            } else {
                break
            }
        }
        if (leng < len)
        {
            return strre;
        }
        else
        {
            return strre + '...';
        }
    }

    /**
     * 对比版本号
     * @param {*} v1 当前版本
     * @param {*} v2 对比版本
     * @returns 0:相同, 1:高于, -1:低于
     */
    function compareVersion(v1, v2) {
        if(!v1 || !v2) return 0;
        v1 = v1 + '';
        v2 = v2 + '';
        v1 = v1.replace('v','');
        v2 = v2.replace('v','');
        v1 = v1.replace('V','');
        v2 = v2.replace('V','');
        v1 = v1.split('.');
        v2 = v2.split('.');

        const len = Math.max(v1.length, v2.length);

        while (v1.length < len) {
          v1.push('0');
        }
        while (v2.length < len) {
          v2.push('0');
        }

        for (let i = 0; i < len; i++) {
          const num1 = parseInt(v1[i]);
          const num2 = parseInt(v2[i]);
      
          if (num1 > num2) {
            return 1;
          } else if (num1 < num2) {
            return -1;
          }
        }
        return 0
    }

}

export default new Util()
